import { message } from 'antd';
import axios, { AxiosError, AxiosResponse } from 'axios';
import AppConsts from '../lib/appconst';

declare const abp: any;

const http = axios.create({
  baseURL: AppConsts.remoteServiceBaseUrl,
  timeout: 30000,
});

http.interceptors.request.use(
  function (config) {
    if (abp.auth.getToken()) {
      config.headers.Authorization = `Bearer ${abp.auth.getToken()}`;
    }

    config.headers['.AspNetCore.Culture'] = abp.utils.getCookieValue(
      'ZeroG33K.Localization.CultureName'
    );
    config.headers['ZeroG33K-TenantId'] = abp.multiTenancy.getTenantIdCookie();

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (!error?.response) {
      message.error({ content: 'Network error. Please try again.' });
      return Promise.reject(error);
    }
    const { data, status } = error.response as AxiosResponse;
    switch (status) {
      case 400: {
        const fieldErrors = data?.error?.validationErrors
          ?.map((v: any) => v?.message)
          ?.filter(Boolean)
          ?.join('; ');
        message.error({ content: fieldErrors || data?.error?.message || 'Request failed.' });
        break;
      }
      case 401:
        localStorage.clear();
        sessionStorage.clear();
        abp.auth.clearToken();
        window.location.href = '/login';
        break;
      case 403:
        message.error({ content: data.error.message });
        break;
      case 404:
        window.location.href = '/not-found';
        break;
      case 500:
        message.error({ content: data.error.message });
        break;
    }
    return Promise.reject(error);
  }
);

export default http;
